export default __webpack_public_path__ + "static/media/premium.08539c69.png";